import React, { Component } from 'react'
import { Sidebar, Segment, Responsive, Menu, List, Container, Icon,Button} from 'semantic-ui-react'
import { Link,withRouter } from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import { connect } from 'react-redux';
import {history} from '../_helpers';
import {styles} from './Styles';

const containerStyle = {
  height: 'auto',
  width: '1400px',
  padding: '1em 0em',
  border:'none',
  'font-family': 'Lato', 
  'font-size': '12px',
  'color': 'grey',
  //'border-style':'solid',
  //'border-width': '0.5px',
 'background-color': '#f9f9f9',
 // backgroundImage: `url(${backgroundImg})`,
 // backgroundSize: 'cover'
};

class SideLeftUncoverInventory extends Component {
  state = { visible: false }

  isActive(match1){
    return this.props.location.pathname.indexOf(match1)!=-1
  }

  onSubmit = (e) => {
    e.preventDefault();
    history.push({pathname: '/profilepremium', state: {toggled: true}})
  }

  render() {
    const {subscription} = this.props;
    return (
      <div>
      <Responsive minWidth={Responsive.onlyComputer.minWidth} >
        {/* <Segment textAlign='left' basic vertical> */}
          <Sidebar.Pushable as={Container} style={containerStyle}>
            <Sidebar as={List} selection animation='uncover' width='thin' visible={true} icon='labeled' vertical size='large'>
              <br/>
               <List.Item disabled>
                       <FormattedMessage id="inventory.computer.sidemenu.menu.top.title"
                                         defaultMessage='Inventory Actions'/>
               </List.Item>  
               <List.Item name='inventory' as={Link} to={{pathname:'/inventory',state:{startPage:1}}}>
                  <Icon name='home' color={this.isActive('/inventory')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('/inventory')?{'color': '#0d77b5'}:{'color': 'black'}}>
                         <FormattedMessage id="inventory.computer.sidemenu.menu.elem0.title"
                                          defaultMessage='Inventory'/>
                    </List.Header>
                  </List.Content>
                </List.Item>               
               <List.Item name='inventory' as={Link} to='/exportinventory'>
                  <Icon name='tasks' color={this.isActive('exportinventory')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('exportinventory')?{'color': '#0d77b5'}:{'color': 'black'}}>
                         <FormattedMessage id="inventory.computer.sidemenu.menu.elem2.title"
                                          defaultMessage='Create inventory'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
{/*                 <List.Item name='Export' as={Link} to='/exportlist'>
                  <Icon name='download' color='blue'/>
                  <List.Content>
                    <List.Header>
                         <FormattedMessage id="inventory.computer.sidemenu.menu.elem3.title"
                                          defaultMessage='Export'/>
                    </List.Header>
                  </List.Content>
                </List.Item> */}
                <List.Item name='Reset stock' as={Link} to='/resetinventory'>
                  <Icon name='redo' color={this.isActive('/resetinventory')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('/resetinventory')?{'color': '#0d77b5'}:{'color': 'black'}}>
                         <FormattedMessage id="inventory.computer.sidemenu.menu.elem4.title"
                                          defaultMessage='Reset stock'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
                <List.Item name='Storage area' as={Link} to='/stockarea'>
                  <Icon name='warehouse' color={this.isActive('/stockarea')?'blue': 'black'}/>
                  <List.Content>
                    <List.Header style={this.isActive('/stockarea')?{'color': '#0d77b5'}:{'color': 'black'}}>
                         <FormattedMessage id="inventory.computer.sidemenu.menu.elem5.title"
                                          defaultMessage='Storage areas'/>
                    </List.Header>
                  </List.Content>
                </List.Item>
                {subscription && (!subscription.customer__membership__membership_type || subscription.customer__membership__membership_type=="Free") && this.isActive('/inventory') &&
                    <div style={{'text-align':'center', 'paddingTop' : '26em'}}>
                      <a style={{color:'grey'}}>
                            <FormattedMessage id="inventory.computer.sidemenu.premium.title.message.subscribe"
                                              defaultMessage='Plan: Basic'/>
                      </a>
                      <Button style={styles.ButtonBluePremium}
                        onClick={(e) => {this.onSubmit(e)}}>
                        <FormattedMessage id="inventory.button.premium"
                                          defaultMessage='Subscribe'/>
                      </Button>
                </div>}
            </Sidebar>
            <Sidebar.Pusher style={{ 'min-height': '100vh',overflowY: 'auto', width: '100%', padding: '2em 2em 20em 2em','background-color':'#fcfcfc'}}>
                  {this.props.children} 
              </Sidebar.Pusher>
          </Sidebar.Pushable>
        {/* </Segment> */}
      </Responsive>
      <Responsive minWidth={Responsive.onlyMobile.maxWidth} maxWidth={Responsive.onlyTablet.maxWidth}>
          <Menu secondary>
              <Menu.Item  onClick={() => this.setState({ visible: !this.state.visible })} >
                  <Icon name="sidebar"/><FormattedMessage id="inventory.mobile.sidemenu.menu.top.title"
                                                          defaultMessage='Inventory'/>
              </Menu.Item>          
          </Menu>
          <Sidebar.Pushable as={Segment}>
              <Sidebar 
                  width='thin'
                  as={Menu} 
                  animation="push" 
                  direction="top" 
                  visible={this.state.visible} 
                  icon="labeled" 
                  horizontal
                  size='tiny'>
                  {/* <Container> */}
                  <Menu.Item name='inventory' as={Link} to={{pathname:'/inventory',state:{startPage:1}}}>
                      <Icon name='home' color={this.isActive('/inventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem0.title"
                                          defaultMessage='Inventory'/>
                    </Menu.Item>
                   <Menu.Item name='inventory' as={Link} to='/exportinventory'>
                      <Icon name='tasks' color={this.isActive('exportinventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem2.title"
                                          defaultMessage='Create inventory'/>
                    </Menu.Item>
{/*                     <Menu.Item name='Export' as={Link} to='/exportlist'>
                      <Icon name='download' color='blue' />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem3.title"
                                          defaultMessage='Export'/>
                    </Menu.Item> */}
                    <Menu.Item name='Reset' as={Link} to='/resetinventory'>
                      <Icon name='redo' color={this.isActive('resetinventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem4.title"
                                          defaultMessage='Reset stock'/>
                    </Menu.Item>
                    <Menu.Item name='Storage area' as={Link} to='/stockarea'>
                      <Icon name='warehouse' color={this.isActive('/stockarea')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem5.title"
                                          defaultMessage='Storage areas'/>
                    </Menu.Item>
                {/* </Container>   */}
              </Sidebar>
              <Sidebar.Pusher dimmed={this.state.visible} style={{ minHeight: '100vh',overflow: 'auto', padding: '2em 0em 20em 2em' }}>
                    {this.props.children}
              </Sidebar.Pusher>
          </Sidebar.Pushable>
       </Responsive>
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
          <Menu secondary>
              <Menu.Item  onClick={() => this.setState({ visible: !this.state.visible })} >
                  <Icon name="sidebar"/><FormattedMessage id="inventory.mobile.sidemenu.menu.top.title"
                                                          defaultMessage='Inventory'/>
              </Menu.Item>          
          </Menu>
          <Sidebar.Pushable as={Segment}>
              <Sidebar 
                  width='thin'
                  as={Menu} 
                  animation="push" 
                  direction="top" 
                  visible={this.state.visible} 
                  icon="labeled" 
                  horizontal
                  size='tiny'>
                  {/* <Container> */}
                  <Menu.Item name='inventory'  as={Link} to={{pathname:'/inventory',state:{startPage:1}}}>
                      <Icon name='home' color={this.isActive('/inventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem0.title"
                                          defaultMessage='Inventory'/>
                    </Menu.Item>
                  <Menu.Item name='inventory' as={Link} to='/exportinventory'>
                      <Icon name='tasks' color={this.isActive('exportinventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem2.title"
                                          defaultMessage='Create inventory'/>
                    </Menu.Item>
{/*                     <Menu.Item name='Export' as={Link} to='/exportlist'>
                      <Icon name='download' color='blue' />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem3.title"
                                          defaultMessage='Export'/>
                    </Menu.Item> */}
                    <Menu.Item name='Reset' as={Link} to='/resetinventory'>
                      <Icon name='redo' color={this.isActive('resetinventory')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem4.title"
                                          defaultMessage='Reset stock'/>
                    </Menu.Item>
                    <Menu.Item name='Storage area' as={Link} to='/stockarea'>
                      <Icon name='warehouse' color={this.isActive('/stockarea')?'blue': 'black'} />
                        <FormattedMessage id="inventory.mobile.sidemenu.menu.elem5.title"
                                          defaultMessage='Storage areas'/>
                    </Menu.Item>
                {/* </Container>   */}
              </Sidebar>
              <Sidebar.Pusher dimmed={this.state.visible} style={{ minHeight: '100vh',overflow: 'auto', padding: '2em 0em 20em 0em' }}>
                    {this.props.children}
              </Sidebar.Pusher>
          </Sidebar.Pushable>
       </Responsive>
    </div>
    )
  }
}

//export default withRouter(SideLeftUncoverInventory)
function mapStateToProps(state) {
  const { subscription } = state.payment;
  return {
      subscription,
  };
}
export default connect(mapStateToProps)(withRouter(SideLeftUncoverInventory))
